import { defineStyleConfig } from '@chakra-ui/react';

export const Stat = defineStyleConfig({
  baseStyle: {
    container: {
      padding: '1rem',
      borderRadius: '24px',
    },
    label: {
      fontSize: 'sm',
      fontWeight: 'medium',
      color: 'gray.500',
      marginBottom: 1,
    },
    number: {
      fontSize: '12px',
      fontWeight: '600',
      lineHeight: 1.2,
    },
    helpText: {
      fontSize: 'xs',
      color: 'gray.500',
      marginTop: 1,
    },
  },
  variants: {
    statty: {
      container: {
        textAlign: 'center',
        padding: '1rem',
        width: '100%',
       
      },
      label: {
        fontSize: 'md',
        fontWeight: '500',
        color: 'text', 
        marginBottom: '0.5rem',
        letterSpacing: '0.2px',
      },
      number: {
        fontSize: '32px',
        fontWeight: '500',
        lineHeight: '1.1',
        marginBottom: '0.5rem',
      },
      helpText: {
        fontSize: 'sm',
        color: 'text',
        fontWeight: '500',
        lineHeight: '1.2',
      },
    },
  },
  defaultProps: {
    variant: 'statty',
  },
});
